import { makeStyles, mergeClasses } from "@fluentui/react-components";
import {
	ArrowDownLeftRegular,
	ArrowUpRightRegular,
} from "@fluentui/react-icons";
import { InteractionDirection } from "@/repository/models";

const useStyles = makeStyles({
	arrow: {
		flexShrink: 0,
		fontSize: "14px",
		verticalAlign: "middle",
	},
});

export interface DirectionArrowProps {
	direction?: InteractionDirection;
	className?: string;
}

// Inline call-direction arrow shown next to contact info; renders nothing for
// interactions without a direction. For the badge variant on interaction icons
// see InteractionComposedIcon.
export const DirectionArrow = (props: DirectionArrowProps) => {
	const classes = useStyles();

	if (props.direction === undefined) {
		return null;
	}

	const className = mergeClasses(classes.arrow, props.className);

	return props.direction === InteractionDirection.Incoming ? (
		<ArrowDownLeftRegular className={className} />
	) : (
		<ArrowUpRightRegular className={className} />
	);
};
